import "//dragontouch.com/cdn/shop/t/10/assets/jquery.js?v=171672860560517612291781165676"
$(window).scroll(function (event) {
  const wst = $(window).scrollTop()
  const st = wst
  const wh = $(window).height()
  console.log(st)
  console.log(wh)
  const cw = $('.compare-bottom-inner').offset().top - 145
  const va = $('.view-all').offset().top
  const vh = $('.view-all').height()
  const vt = va - vh
  if (st > cw && st < vt) {
    console.log(111)
    $('.compare-fixed').slideDown(100)
  } else {
    console.log(222)
    $('.compare-fixed').slideUp(100)
  }
})
$(function () {
  $('.view-all-box').click(function (e) {
    $('.view-all-item').hide()
    $('.view-less-item').show()
    $('.compare-bottom-item-hide').slideDown(100)
  })
  $('.view-less-box').click(function (e) {
    $('.view-less-item').hide()
    $('.view-all-item').show()
    $('.compare-bottom-item-hide').slideUp(100)
  })
  $('.view-all-box').hover(
    function () {
      console.log(123)
      $('.view-all-line').addClass('container-spec-one')
      $('.view-all-icon').addClass('view-all-icon-spec')
    },
    function () {
      console.log(234)
      $('.view-all-line').removeClass('container-spec-one')
      $('.view-all-icon').removeClass('view-all-icon-spec')
    }
  )
  $('.view-less-box').hover(
    function () {
      console.log(123)
      $('.view-less-line').addClass('container-spec-two')
      $('.view-less-icon').addClass('view-less-icon-spec')
    },
    function () {
      console.log(234)
      $('.view-less-line').removeClass('container-spec-two')
      $('.view-less-icon').removeClass('view-less-icon-spec')
    }
  )
})
